    <section class="blog-area {{pt}} {{pb}}">

    <div class="container">
        <div class="section-title">
            <h2>Últimas Noticias</h2>
            <p>Mantente informado con las últimas actualizaciones en tecnología y computación.</p>
        </div>

        <div class="row">
            <div *ngFor="let item of newsList" class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <a class="d-block"><img src="{{item.imageUrl}}" alt="Image"></a>

                    <div class="blog-content-wrap">
                        <ul>
                            <li style="cursor: pointer;" title="{{item.authorName}}"><a><i class="flaticon-male"></i> {{item.authorName | truncate:12}}</a></li>
                            <li class="date"><i class="flaticon-appointment"></i>{{item.postedOn | date: 'dd MMMM y' }}</li>
                        </ul>
                        <h5><a>{{item.title}}</a></h5>
                        <p>{{item.summary | truncate:200}}</p>
                        <a  (click)="goToNews(item)" class="read-more pointer">Leer más<i class="bx bx-chevron-right"></i></a>
                    </div>
                </div>
            </div>


        </div>
    </div>
</section>